export enum HelpType {
  Faq = 1,
  ContentDescription = 2,
  Rules = 3,
  Privacy = 4,
  Cookies = 5,
  Instruction = 6
}
